<template>
  <ui-component-modal
    :modalTitle="'Remove option'"
    confirmButtonCssClass="is-danger"
    :onClickCancel="onClickCancel"
    :showModal="showModal"
    :buttonLabelConfirm="$t('Form.Control.Delete')"
    :onClickSave="deleteReservationOption"
    :isSaving="isDeleting"
    :isSavingError="isDeletingError"
    :hideFooterButtons="isDeletingError"
    :disableSaveButton="!isDeleteConfirmed"
    @closeModal="onClickCancel"
  >
    <template slot="modalTitle"></template>
    <template v-slot:content>
      <div
        class="has-margin-bottom is-size-5 has-text-centered"
        v-html="
          'Are you sure you want to remove this option from the reservation?'
        "
      ></div>

      <div class="has-text-centered">
        <BaseCheckbox
          v-model="isDeleteConfirmed"
          class="has-text-left"
          :label="'Yes, I am sure!'"
        />
      </div>

      <div
        v-if="reservation.ReservationSetIds.length > 0"
        class="has-margin-top"
      >
        <table class="table is-fullwidth">
          <tbody>
            <tr>
              <td>Change all in set</td>
              <td>
                <div class="tabs is-toggle is-small">
                  <ul>
                    <li :class="{ 'is-active': changeAllInSet === true }">
                      <a @click="changeAllInSet = true">
                        <span>Yes</span>
                      </a>
                    </li>
                    <li :class="{ 'is-active': changeAllInSet === false }">
                      <a @click="changeAllInSet = false">
                        <span>No</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <Message v-if="changeAllInSet" :message="'Change all in set'" />
      </div>
    </template>
  </ui-component-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/eventbus/event-bus'
import reservationProvider from '@/providers/reservation'

const BaseCheckbox = () =>
  import(
    /* webpackChunkName: "settings-options" */ '@/components/UI/Form/BaseCheckbox'
  )
const Message = () => import('@/components/UI/Message')

export default {
  components: {
    BaseCheckbox,
    Message,
  },

  props: {
    option: null,
    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      changeAllInSet: false,
      isDeleteConfirmed: false,
      isDeleting: false,
      isDeletingError: false,
    }
  },

  computed: {
    ...mapState('reservationStore', ['reservation']),
  },

  methods: {
    ...mapMutations('reservationStore', ['setReservation']),

    deleteReservationOption() {
      let self = this

      let optionIndex = self.reservation.Options.findIndex(
        (o) => o.Id === self.option.Id
      )

      if (optionIndex > -1) {
        self.reservation.Options.splice(optionIndex, 1)

        if (!self.isDeleting) {
          self.isDeleting = true

          let criteria = {
            Id: self.option.Id,
            ChangeAllInSet: self.changeAllInSet,
          }

          reservationProvider.methods
            .deleteReservationOption(self.reservation.Id, criteria)
            .then((response) => {
              if (response.status === 200) {
                self.setReservation(response.data)

                self.isDeletingSuccess = true

                EventBus.$emit('showToast', {
                  type: 'info',
                  message: 'Reservation data updated!',
                })

                this.onClickCancel()
              }
            })
            .catch((error) => {
              self.isDeletingError = true
            })
            .finally(() => {
              self.isDeleting = false
            })
        }
      } else {
        self.isSavingError = true
        self.isDeleting = false
      }
    },
  },
}
</script>
